import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { UserService } from 'app/configuration/user/user.service';
import { ApiService } from '@core/services/api';

@Injectable({
  providedIn: 'root',
})
export class ManageUserService {
  private _selectedContract$ = new BehaviorSubject<any>(null);
  private _unsubscribeAll: Subject<boolean> = new Subject();
  // Observable para escuchar cambios
  selectedContract$ = this._selectedContract$.asObservable();

  constructor(private _mStorage: manageStorageService, private _api: ApiService) { }

  /**
   * Actualiza el contrato seleccionado en User
   *
   * @param newContract - El nuevo contrato a guardar
   */
  updateSelectedContract(newContract: any): void {
    // Guardar el nuevo contrato en User
    this._mStorage.setItmStorage('selectedContract', newContract);

    // Emitir el cambio a través del BehaviorSubject
    this._selectedContract$.next(newContract);
  }

  /**
   * Carga el contrato inicial desde User
   *
   * @returns El contrato guardado en User o null si no existe
   */
  loadSelectedContract(): any {
    // Obtener el contrato almacenado en User
    const storedInfo = this._mStorage.getPropertie('selectedContract');
    if (storedInfo) {
      // Emitir el contrato inicial a través del BehaviorSubject
      this._selectedContract$.next(storedInfo);
      return storedInfo;
    }

    // Retornar null si no hay contrato almacenado
    return null;
  }

  /**
   * 
   * @returns 
   */
  getUserDetail() {
    let queryParams = { "operacion": '936', "usuario": this._mStorage.getPropertie('s_userSession')?.principal, "cmd":'', "cip":'',"nuevo":'',"sid":'' }
    
    return new Promise((rslvAuth, rjctAuth) => {
      this._api
        .gEt('comunes/v1/usuarioContratos', queryParams)
        .pipe( takeUntil(this._unsubscribeAll))
        .subscribe(
          {
            next: (apiRspnsUserDetail: any) => {             
              rslvAuth(apiRspnsUserDetail.body.data.contratos)
            },
            error: (eRR) => rjctAuth(eRR)
          }
        )
    });

  }
}
